import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import {
  CompanyNamedLookupResponse,
  CompanyOrganisationalLevelResponse,
  CompanyResponse,
} from '../../company.model';
import { DataTableColumn } from '@shared/components/data-table.component';
import { useCompanyDetailsActionMenu } from './company-details-action-menu-composable';
import { CompanyDetailsActions } from './company-details-actions-enum';
import { SHARED_IMPORTS } from '@shared/modules/shared-imports.module';

@Component({
  selector: 'company-detail-panels',
  imports: [...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './company-detail-panels.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CompanyDetailPanelsComponent {
  readonly CompanyDetailsActions = CompanyDetailsActions;
  readonly companyId = input<string>('');
  readonly canManage = input(false);
  readonly data = input<CompanyNamedLookupResponse[]>([]);
  readonly detailsTitle = input<string>('Title');

  readonly manageDetails = output<{
    division?: CompanyNamedLookupResponse;
    action: CompanyDetailsActions.Create | CompanyDetailsActions.Edit | CompanyDetailsActions.Toggled;
  }>();

  protected readonly columns: DataTableColumn<CompanyNamedLookupResponse>[] = [
      {
        id: 'name',
        header: 'Name',
        value: (data) => data.name,
        cellClass: 'px-3 py-3 font-medium',
      },
      {
        id: 'status',
        header: 'Status',
        value: (data) => (data.isActive ? 'Active' : 'Inactive'),
        cellClass: 'px-3 py-3',
      },
  ];
  readonly actionMenuItems = useCompanyDetailsActionMenu().companyDetailsActionMenuItems;
  readonly actions: Record<string, any> = {
    [CompanyDetailsActions.Toggled]: this.manageDetails,
    [CompanyDetailsActions.Edit]: this.manageDetails,
    [CompanyDetailsActions.Create]: this.manageDetails,
  };
}